import { baseSubscription } from '@/utils/subscriptionHandler';
import Subscriptions from '@/services/graphql/collectionProducts';
const subscribeOnProductUpdate = (variables, next) => baseSubscription({
  variables,
  next,
  subscriptionFunction: Subscriptions.subscribeOnProductUpdate,
  unsubscribe: false,
},);
export { subscribeOnProductUpdate };
